import { render, staticRenderFns } from "./MessageStat.vue?vue&type=template&id=3427fb0d&scoped=true&lang=html&"
import script from "./MessageStat.vue?vue&type=script&lang=js&"
export * from "./MessageStat.vue?vue&type=script&lang=js&"
import style0 from "./MessageStat.vue?vue&type=style&index=0&id=3427fb0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3427fb0d",
  null
  
)

export default component.exports